import { CircularProgress } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Stack } from "@mui/system";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLoading from "./useLoading";

const Loading = () => {
    const { loading, setLoading } = useLoading();
    const { pathname } = useLocation();

    useEffect(() => {
        setLoading(false);
    }, [pathname, setLoading]);

    if (!loading)
        return null;

    return (
        <Stack
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: theme => alpha(theme.palette.grey[500], 0.5),
                zIndex: 1300,
                pointerEvents: 'all',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress size={150} sx={{ color: theme => theme.palette.primary.light }} />
        </Stack>
    )
}

export default Loading;